const financial = [
	{
		path: '/network/financial/payouts',
		name: 'network-financial-payouts-overview',
		component: () => import('@/views/network/financial/payouts/overview.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/banks/list',
		name: 'network-financial-banks-list',
		component: () => import('@/views/network/financial/banks/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/affiliates/list',
		name: 'network-financial-affiliates-list',
		component: () => import('@/views/network/financial/affiliates/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/affiliates/:userId/view',
		name: 'network-financial-affiliates-view',
		component: () => import('@/views/network/financial/affiliates/view.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/affiliates/transactions',
		name: 'network-financial-affiliates-transactions',
		component: () => import('@/views/network/financial/affiliates/transactions.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/affiliates/documents/list',
		name: 'network-financial-affiliates-documents-list',
		component: () => import('@/views/network/financial/affiliates/documents/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/affiliates/commissions/list',
		name: 'network-financial-affiliates-commissions-list',
		component: () => import('@/views/network/financial/affiliates/commissions/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/affiliates/requests/list',
		name: 'network-financial-affiliates-requests-list',
		component: () => import('@/views/network/financial/affiliates/requests/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/cupons/list',
		name: 'network-financial-cupons-list',
		component: () => import('@/views/network/financial/cupons/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/currencies/list',
		name: 'network-financial-currencies-list',
		component: () => import('@/views/network/financial/currencies/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/expenses-categories/list',
		name: 'network-financial-expenses-categories-list',
		component: () => import('@/views/network/financial/expenses-categories/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/invoices/list',
		name: 'network-financial-invoices-list',
		component: () => import('@/views/network/financial/invoices/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/invoices/create',
		name: 'network-financial-invoices-create',
		component: () => import('@/views/network/financial/invoices/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/invoices/edit/:id',
		name: 'network-financial-invoices-edit',
		component: () => import('@/views/network/financial/invoices/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/payment-methods/list',
		name: 'network-financial-payment-methods-list',
		component: () => import('@/views/network/financial/payment-methods/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/payment-fees/list',
		name: 'network-financial-payment-fees-list',
		component: () => import('@/views/network/financial/payment-fees/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/payment-refunds/list',
		name: 'network-financial-payment-refunds-list',
		component: () => import('@/views/network/financial/payment-refunds/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/payment-periods/list',
		name: 'network-financial-payment-periods-list',
		component: () => import('@/views/network/financial/payment-periods/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/payment-status/list',
		name: 'network-financial-payment-status-list',
		component: () => import('@/views/network/financial/payment-status/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/payment-taxes/list',
		name: 'network-financial-payment-taxes-list',
		component: () => import('@/views/network/financial/payment-taxes/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/payment-types/list',
		name: 'network-financial-payment-types-list',
		component: () => import('@/views/network/financial/payment-types/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/sale-pipelines/list',
		name: 'network-financial-sale-pipelines-list',
		component: () => import('@/views/network/financial/sale-pipelines/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/custom-carts/list',
		name: 'network-custom-carts-list',
		component: () => import('@/views/network/financial/custom-carts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/custom-carts/create',
		name: 'network-custom-carts-create',
		component: () => import('@/views/network/financial/custom-carts/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/custom-carts/edit/:bundleId',
		name: 'network-custom-carts-edit',
		component: () =>
			import(/* webpackChunkName: "NetworkCustomCartsEdit" */ '@/views/network/financial/custom-carts/new.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/abandoned-carts',
		name: 'network-abandoned-carts-list',
		component: () => import('@/views/network/financial/abandoned-carts/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
	{
		path: '/network/financial/failed-payments/list',
		name: 'network-financial-failed-payments-list',
		component: () => import('@/views/network/financial/failed-payments/list.vue'),
		meta: {
			layout: 'content',
			module: 'MGN,financial',
		},
	},
]

export default financial
